import React, { FC } from 'react'

import { IconShareYourMinsProps } from './IconShareYourMins.types'
import * as Styled from './styles/IconShareYourMins.style'

import { nonThemeableRules } from '../../ruleSet'

const IconShareYourMins: FC<IconShareYourMinsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconShareYourMinsProps['size'],
  isResponsive = false,
}: IconShareYourMinsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M20.892 31.945c5.507 0 9.97-1.55 9.97-3.462 0-1.913-4.463-3.463-9.97-3.463-5.506 0-9.97 1.55-9.97 3.463 0 1.912 4.464 3.462 9.97 3.462Z'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M30.863 28.482v6.535c-1.303 1.525-5.25 2.325-9.97 2.325-4.72 0-8.67-1.107-9.97-2.632v-6.368'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M13.137 36.098v4.432c1.303 1.523 5.25 2.5 9.97 2.5 4.72 0 8.67-.692 9.97-2.215v-5.547s0-1.108-2.215-1.108'
          stroke='#0D0D0D'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M38.215 13.152v.09a2.447 2.447 0 0 1-.615 1.36l-1.55 1.608-3.36 3.482a1.02 1.02 0 0 1-1.75-.704v-.613a1.232 1.232 0 0 0 0-.168c-.08-.61-.5-1.035-1.25-1.082-3.435-.227-7.023.323-10.04 2.038-.527.297-1.04.617-1.567.917a.625.625 0 0 1-.908-.75c1.185-3.5 3.058-5.847 5.047-7.407 2.698-2.113 5.61-2.75 7.305-2.805h.163a1.283 1.283 0 0 0 1.25-1.293v-.562a1 1 0 0 1 1.025-1.02h.02a1 1 0 0 1 .71.315l2.555 2.597 2.358 2.388.095.107c.274.347.447.763.5 1.202.011.1.015.2.012.3Z'
          stroke='#E60000'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconShareYourMins
